import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MilestoneSection.css';
// import Oncologist from "../../Assets/milestone.png"
import milestone1 from "../Assets/milestone1.png"
import milestone2 from "../Assets/milestone1.png"
import milestone3 from "../Assets/milestone1.png"
import CourseClassesSection from './CourseClassesSection';


const milestones = [
  {
    title: '1. Beginner – Start With the Basics',
        path: '/course/Beginner',
    content: {
      img: milestone1, // Replace with your actual image path
      text: (
      <>
        <p>
          If you’re just getting started with English or know the basics, our Beginner English course is a great place to begin. This level covers the core skills you need.
        </p>
        <ul>
          <li>Basic Grammar and Vocabulary: Practice making sentences, use common words, and gain confidence talking about simple things with others.</li>
          <li>Pronunciation Practice: Work on speaking clearly so people can understand what you're saying.</li>
          <li>Reading and Writing Skills: Learn how to read short passages and write basic notes, emails, or messages.</li>
          <li>Listening Comprehension: Get better at understanding everyday English conversations.</li>
        </ul>
        <p>
          This program fits well if you are a school student just beginning to learn, or an adult trying to pick up English without feeling stressed. Lessons keep you involved by using real-life examples making learning simple and fun.
        </p>
        <p>
          You will connect with an English-speaking tutor who gives you direct feedback to fix your mistakes faster. By the end of this level, you should feel ready to have basic conversations, follow simple directions, and read everyday English texts.
        </p>
        <CourseClassesSection />
      </>
    )
  }
  },
  {
    title: '2. Intermediate – Take Your Skills Further',
    path: '/course/Intermediate',
    content: {
      img: milestone2,
            text: (
      <>
        <p>
          If you’re just getting started with English or know the basics, our Beginner English course is a great place to begin. This level covers the core skills you need.
        </p>
        <ul>
          <li>Basic Grammar and Vocabulary: Practice making sentences, use common words, and gain confidence talking about simple things with others.</li>
          <li>Pronunciation Practice: Work on speaking clearly so people can understand what you're saying.</li>
          <li>Reading and Writing Skills: Learn how to read short passages and write basic notes, emails, or messages.</li>
          <li>Listening Comprehension: Get better at understanding everyday English conversations.</li>
        </ul>
        <p>
          This program fits well if you are a school student just beginning to learn, or an adult trying to pick up English without feeling stressed. Lessons keep you involved by using real-life examples making learning simple and fun.
        </p>
        <p>
          You will connect with an English-speaking tutor who gives you direct feedback to fix your mistakes faster. By the end of this level, you should feel ready to have basic conversations, follow simple directions, and read everyday English texts.
        </p>
        <CourseClassesSection />
      </>
    )
    }
  },
  {
    title: '3. Advanced – Take Your Communication Skills Higher',
        path: '/course/Advanced',
    content: {
      img: milestone3,
            text: (
      <>
        <p>
          If you’re just getting started with English or know the basics, our Beginner English course is a great place to begin. This level covers the core skills you need.
        </p>
        <ul>
          <li>Basic Grammar and Vocabulary: Practice making sentences, use common words, and gain confidence talking about simple things with others.</li>
          <li>Pronunciation Practice: Work on speaking clearly so people can understand what you're saying.</li>
          <li>Reading and Writing Skills: Learn how to read short passages and write basic notes, emails, or messages.</li>
          <li>Listening Comprehension: Get better at understanding everyday English conversations.</li>
        </ul>
        <p>
          This program fits well if you are a school student just beginning to learn, or an adult trying to pick up English without feeling stressed. Lessons keep you involved by using real-life examples making learning simple and fun.
        </p>
        <p>
          You will connect with an English-speaking tutor who gives you direct feedback to fix your mistakes faster. By the end of this level, you should feel ready to have basic conversations, follow simple directions, and read everyday English texts.
        </p>
        <CourseClassesSection />
      </>
    )
    }
  }

];

const MilestoneSection = () => {
const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate(); // 👈 Add this
const location = useLocation(); // 👈 current route
const sectionRef = useRef(null);
useEffect(() => {
  const currentIndex = milestones.findIndex(m => m.path === location.pathname);
  if (currentIndex !== -1) {
    setActiveIndex(currentIndex);
    // Scroll to section
    setTimeout(() => {
      sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100); // slight delay to ensure DOM is ready
  }
}, [location.pathname]);
const toggleAccordion = (index) => {
    const isOpen = index === activeIndex;
    setActiveIndex(isOpen ? null : index);
    navigate(milestones[index].path); // Navigate to that tab’s route
  };


  return (
<div className="milestone-container" ref={sectionRef}>
      {milestones.map((item, index) => (
        <div key={index}>
          <div
            className={`milestone-category ${
              activeIndex === index ? 'teal-bg' : 'accordian-bg'
            }`}
            onClick={() => toggleAccordion(index)}
          >
            {item.title}
            <span className="icon">
              {activeIndex === index ? '▴' : '▾'}
            </span>
          </div>

          {activeIndex === index && (
            <div className="milestone-content">
              <div className="accordion-image">
                <img src={item.content.img} alt={item.title} />
              </div>
              <div className="milestone-text">
                <p>{item.content.text}</p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MilestoneSection;
